import React from "react"
import Layout from "components/layout/Layout";
import { ROUTES } from "utils/routes";

const ExpiredToken = () => {

    return (
        <Layout>
            <div className="flex items-start pt-32 md:pt-0 md:items-center bg-gray-50 h-screen" >
                <div className="w-full px-4 md:px-32">
                    <h1 className="text-2xl md:text-3xl text-red-500 font-bold"> Password reset link is expired </h1>

                    <p className="mt-8 text-left"> <a href={ROUTES.LOGIN} className="text-blue-500 hover:text-pblue font-medium">Go to home</a></p>

                </div>
            </div>
        </Layout>

    )
}

export default ExpiredToken
